export default __webpack_public_path__ + "static/media/broadcast-import.a58d1f4d.png";